import { APIService } from "services";

export const getBlood_Grp = async (pageNo,pageSize,search) => {
    let res;
    if(search.length===0) {
        res = await getAllBlood_Grp(pageNo,pageSize);
    }
    else{
        try {
            res = await searchBlood_Grp(search,pageNo,pageSize);
        } catch(err) {
             return { records:[], totalCount:0 }
        }
    }
    if(res && res.data){
    return res.data;
    }else{
    return { records:[], totalCount:0 }
    }
    
}


export const addBlood_Grp = (data) => {
return APIService.api().post(`/blood_grp`,data)
}
export const updateBlood_Grp = (blood_grp_id,data) => {
return APIService.api().patch(`/blood_grp/${blood_grp_id}`,data)
}
export const getAllBlood_Grp = (pageNo,pageSize) => {
return APIService.api().get(`/blood_grp/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const getOneBlood_Grp = (blood_grp_id) => {
return APIService.api().get(`/blood_grp/${blood_grp_id}`)
}
export const searchBlood_Grp = (searchKey,pageNo,pageSize) => {
return APIService.api().get(`/blood_grp/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const deleteBlood_Grp = (blood_grp_id) => {
return APIService.api().delete(`/blood_grp/${blood_grp_id}`)
}
